// extracted by mini-css-extract-plugin
export var card = "_5w-0";
export var failedIcon = "_5w-4";
export var failedIconBadge = "_5w-3";
export var icon = "_5w-1";
export var successIcon = "_5w-2";